import { Navigate } from 'react-router-dom';
import { usePublicRedirect } from '@shared/hooks/use-me';
import { LandingFooter } from './landing-footer';
import { Hero } from './landing-sections/hero';
import { HowItWorks } from './landing-sections/how-it-works';
import { ServicesSection } from './landing-sections/services-section';
import { KeyNumbers } from './landing-sections/key-numbers';
import { WhyUs } from './landing-sections/why-us';
import { Testimonials } from './landing-sections/testimonials';
import { Faq } from './landing-sections/faq';
import { FinalCta } from './landing-sections/final-cta';

export function LandingPage() {
  const { target, waiting } = usePublicRedirect();

  if (waiting) return null;
  if (target) return <Navigate to={target} replace />;

  return (
    <div className="w-full bg-white font-sans text-gray-900 selection:bg-emerald-100 selection:text-emerald-900">
      <Hero />
      <HowItWorks />
      <ServicesSection />
      <KeyNumbers />
      <WhyUs />
      <Testimonials />
      <Faq />
      <FinalCta />
      <LandingFooter />
    </div>
  );
}
